import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=f16a24f6&scoped=true&lang=html&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=f16a24f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16a24f6",
  null
  
)

component.options.__file = "Terms.vue"
export default component.exports